import { useCallback, useState } from 'react';
import { useT } from '../../hooks/useT';
import ImageCarousel from '../../components/ImageCarousel/ImageCarousel';
import DemoOverlay from '../../components/DemoOverlay/DemoOverlay';
import { getDemo } from '../../utils/demoRegistry';
import styles from './PortfolioItem.module.css';

function PortfolioItem({ titleKey, period, subtitleKey, descriptionKey, images = [], tags = [], links = [], reverse = false, demoSlug = '' }) {
  const t = useT();
  const title = t(titleKey);
  const demo = getDemo(demoSlug);
  const [demoOpen, setDemoOpen] = useState(false);
  const closeDemo = useCallback(() => setDemoOpen(false), []);

  return (
    <div className={`${styles.card} ${reverse ? styles.reverse : ''}`}>
      <div className={styles.media}>
        <ImageCarousel images={images} alt={title} />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        {period && <p className={styles.period}>{period}</p>}
        {subtitleKey && <p className={styles.subtitle}>{t(subtitleKey)}</p>}
        <p className={styles.description}>{t(descriptionKey)}</p>
        {tags.length > 0 && (
          <div className={styles.tags}>
            {tags.map((tag) => (
              <span key={tag} className={styles.tag}>{tag}</span>
            ))}
          </div>
        )}
        {(links.length > 0 || demo) && (
          <div className={styles.links}>
            {demo && (
              <button
                type="button"
                className={styles.tryLive}
                onClick={(e) => {
                  e.stopPropagation();
                  setDemoOpen(true);
                }}
              >
                <span className={styles.liveDot} aria-hidden="true" />
                {t('demo.tryLive')}
              </button>
            )}
            {links.map((link) => (
              <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
      {demoOpen && <DemoOverlay demo={demo} title={title} onClose={closeDemo} />}
    </div>
  );
}

export default PortfolioItem;
